module.exports = __webpack_public_path__ + "img/d010_6.185a6fab.png";